var __default__ = {root:'m_f59ffda3',label:'m_be049a53','label--outline':'m_3904c1af','label--filled':'m_fa109255','label--light':'m_f7e165c3',iconWrapper:'m_9ac86df9',checkIcon:'m_d6d72580',input:'m_bde07329'};
export default __default__;